export default "__VITE_ASSET__KyavJAXW__"